import { render, staticRenderFns } from "./email-table.vue?vue&type=template&id=78c351e4&scoped=true&"
import script from "./email-table.vue?vue&type=script&lang=ts&"
export * from "./email-table.vue?vue&type=script&lang=ts&"
import style0 from "./email-table.vue?vue&type=style&index=0&id=78c351e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c351e4",
  null
  
)

export default component.exports